<template>
<div class="card">
    <loading :active.sync="retrieveTenantListLoading" 
        :can-cancel="true"
        :is-full-page="false"></loading>
    <div class="card-header d-flex align-items-center justify-content-between">
        <h3>Tenant List</h3> 
    </div> 
    <div class="card-body">
        <div class="d-flex" >
            <button v-if="role === 'Supervisor'" type="button" class="btn btn-danger flex-grow-0" v-on:click="showTenantPopup()">Tenant 생성</button>
        </div>
        <table class="table table-bordered table-striped table-hover">
            <colgroup>
                    <col width="15%" />
                    <col width="60%" />
                    <col width="20%" />
            </colgroup>
            <thead>
                <tr class="text-center device-table-header">
                    <th>Tenant ID</th>
                    <th>Tenant Name</th>
                    <th>Detail</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="tenant in tenantList">  <!-- v-bind:key="license.deviceId" -->
                    <td class="text-center">{{ tenant.tenantId }}</td>
                    <td>{{ tenant.tenantName }}</td>
                    <td class="text-center">
                        <button type="button" class="btn btn-blue" v-bind:style="{width:'75%'}" @click="showTenantPopup(tenant.tenantId)">Detail</button>
                    </td>
                </tr>
                <tr v-show="noResult">
                    <td class="text-center" colspan="7">결과가 없습니다.</td>
                </tr>
            </tbody>
        </table>
        <!-- <div class="text-center">
            <button class="btn btn-view-more" v-bind:style="{width:'40%'}" v-on:click="seeMore()" :disabled="tenantList.length == total">더보기 ({{ tenantList.length }} / {{ total }})</button>
        </div> -->
    </div> <!--card-body-->
    <!--Detail modal start-->
    <b-modal size="lg" ref="modalRequestLicense" header-class="detail-header" title="Tenant Information" ok-only ok-variant="secondary" ok-title="Close"> <!-- size = xl, lg, sm -->
        <div style="display: inline-block;" v-show="existentFlag"> 
            <h5>Tenant Id : {{ tenantDetail.tenantId }}</h5>
        </div>
        <table class="table table-striped table-bordered table-hover shadow-sm mt-2">
             <loading :active.sync="requestTenantLoading" 
                :can-cancel="false" 
                :is-full-page="false"></loading>
                <!-- :loader="dots" 이거 왜 안되지? -->
            <colgroup>
                    <col width="20%" />
                    <col width="50%" />
                    <col width="30%" />
            </colgroup>
            <thead class="script-header" >
                <tr class="text-center">
                    <th>Name</th>
                    <th>Value</th>
                    <th>Description</th>
                </tr>
            </thead>
            <tbody>
                <tr v-show="!existentFlag">
                    <td>Tenant ID *</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="Tenant ID" name="serial" v-model="tenantDetail.tenantId">
                        </div>
                    </td>
                    <td>Tenant 고유 id</td>
                </tr>
                <tr>
                    <td>Tenant Name *</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="Tenant Name" name="tenantName" v-model="tenantDetail.tenantName" v-validate="'required'">
                            <div class="alert-danger" v-if="submitted && errors.has('alias')">{{ errors.first('alias') }}</div>
                        </div>
                    </td>
                    <td>Tenant 이름</td>
                </tr>
                <tr>
                    <td>Description</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="Description" name="description" v-model="tenantDetail.description">
                            <div class="alert-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</div>
                        </div>
                    </td>
                    <td>Tenant 설명</td>
                </tr>
                <tr>
                    <td>Kakao Bot ID</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1">
                            <input class="form-control" placeholder="Kakao Bot ID" name="kakaoBotId" v-model="tenantDetail.kakaoBotId">
                            <div class="alert-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</div>
                        </div>
                    </td>
                    <td>https://i.kakao.com > 나의 봇 > 봇 선택 > 설정 > 봇 ID</td>
                </tr>
                <tr>
                    <td>Email Domain</td>
                    <td>
                        <div class="form-group mr-2 flex-grow-1 form-inline">
                            @&nbsp;<input class="form-control flex-fill" placeholder="Email Domain" name="domain" v-model="tenantDetail.emailDomain">
                        </div>
                    </td>
                    <td>이메일의 도메인 부분</td>
                </tr>       
            </tbody>
        </table>
        <div class="text-center pb-2" style="display: inline-block; float: right;" >
            <button type="button" class="btn btn-success" v-on:click="updateTenant()">{{ existentFlag ? 'Update' : 'Submit' }}</button>
            <button v-show="!existentFlag" type="button" class="btn btn-danger" style="margin-left: 10px;" v-on:click="resetRequestForm()">Reset</button>
            <button v-show="existentFlag" type="button" class="btn btn-danger" style="margin-left: 10px;" v-on:click="deleteTenant()">Delete</button>
        </div>
    </b-modal>
    <!--Detail modal end -->
<!--Message Modal-->
    <b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary" ok-title="Close">
        <p class="my-4 text-center">{{ msgContent }}</p>
    </b-modal>   
</div> <!--card-->   

</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'Tenant',
    data() {
        return {
            tenantList: [],  // retrieveTenantList의 결과
            total: 0,  // 이 화면의 검색 조건에 맞는 WorkMan에 있는 license의 총 개수

            smallestSerial: -1,  // 더보기 할 때 사용하는 기준점

            noResult: false,  // retrieveTenantList 에서 결과가 없으면 noResult를 true로 만들어서 결과 없음을 보여줌

            existentFlag: false,
            tenantDetail: {},

            submitted: false,  // true가 되면 validate 를 진행함
            retrieveTenantListLoading: false,  // 라이센스 리스트를 보여주는 곳의 로딩바
            requestTenantLoading: false,  // 라이센스 신청 폼에서 보여주는 로딩바
            msgStatus: '',  // alert popup 의 status 인데 사용하진 않고, 아래 content는 보여줌
            msgContent: ''
        }
    },
    components: {
        Loading
    },
    computed: {
        deviceList: function() {
            return this.$store.getters.getPeonList;
        },
        role() {
            let user = JSON.parse(localStorage.getItem('user'));

            if (user && user.role) {
                return user.role;
            } else {
                return '';
            }
        }
    },
    // filters: {
    //     formatDate: function(value) {
    //         if (value) {  // 왜 안되는지 원..
    //             return this.$moment(String(value)).format('yyyy-MM-dd');
    //         }
    //     }   
    // },
    methods: {
        showMessage(status, message) {
            this.msgStatus = status;
            this.msgContent = message;
            
            this.$bvModal.show('messageModal');
        },
        showTenantPopup(tenantId) {
            
            this.existentFlag = false;

            this.resetRequestForm();

            if(tenantId != null) {
                var params = {'tenantId' : tenantId};

                axios.get('user/retrieveTenantList', {
                    params: params,
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': accessToken()
                    }
                }).then(response => {
                    
                    if(response.data.body.list == null || response.data.body.list.length == 0 || response.data.body.list.length > 1) {
                        this.showMessage(-1, "wrong information");
                        return;
                    }

                    this.existentFlag = true;
                    this.tenantDetail = response.data.body.list[0];

                }).catch(error => {
                    if (error.status != 401) {
                        this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                    }
                }).finally(() => {
                    
                });
            }

            this.$refs['modalRequestLicense'].show();
        },
        resetRequestForm() {
            this.tenantDetail = {};

            //초기화
            // this.tenantDetail.tenantId = '';
            // this.tenantDetail.tenantName = '';
            // this.tenantDetail.description = '';
            // this.tenantDetail.emailDomain = '';
        },
        seeMore() {
            if (this.tenantList && this.tenantList.length > 0) {
                this.smallestSerial = this.tenantList[this.tenantList.length - 1].serial; 
            }

            this.retrieveTenantList();
        },
        reloadretrieveTenantList() {
            this.smallestSerial = -1;
            this.tenantList = [];

            this.retrieveTenantList();
        },
        retrieveTenantList() {
            var params = {};

            axios.get('user/retrieveTenantList', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.submitted = false;

                response.data.body.list.forEach((item, index, array) => {
                    this.tenantList.push(item);
                });

                this.total = response.data.body.list.length;
                this.noResult = this.total == 0 ? true : false;
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.retrieveTenantListLoading = false;
            });
        },
        updateTenant() {

            this.submitted = true;

            this.$validator.validate().then(valid => {
                if (valid) {
                    
                    //유효성 검사
                    if(this.tenantDetail.tenantId == null || this.tenantDetail.tenantId === '') {
                        this.showMessage(-1, "Tenant ID는 필수 입력값입니다.");
                        return;
                    }

                    if(this.tenantDetail.tenantName == null || this.tenantDetail.tenantName === '') {
                        this.showMessage(-1, "Tenant Name은 필수 입력값입니다.");
                        return;
                    }

                    const regExp = /^[0-9]+$/;
                    if(!regExp.test(this.tenantDetail.tenantId)) {
                        this.showMessage(-1, "Tenant ID는 숫자만 입력 가능합니다.");
                        return;
                    }

                    if(this.tenantDetail.kakaoBotId != null && this.tenantDetail.kakaoBotId !== '') {
                        if(this.tenantDetail.kakaoBotId.length != 24) {
                            this.showMessage(-1, "Kakao Bot ID는 24자리입니다.");
                            return;
                        }
                    }

                    if(this.tenantDetail.emailDomain != null && this.tenantDetail.emailDomain !== '') {
                        if(this.tenantDetail.emailDomain.search("@") != -1) {
                            this.showMessage(-1, "Email Domain에는 '@'를 입력할 수 없습니다.");
                            return;
                        }
                    }

                    this.requestTenantLoading = true;
                    var params = {
                        'tenantId': this.tenantDetail.tenantId.trim(),
                        'tenantName': this.tenantDetail.tenantName.trim(),
                        'description': this.tenantDetail.description ? this.tenantDetail.description.trim() : '',
                        'kakaoBotId': this.tenantDetail.kakaoBotId ? this.tenantDetail.kakaoBotId.trim() : '',
                        'emailDomain': this.tenantDetail.emailDomain ? this.tenantDetail.emailDomain.trim() : '',
                    };
                    
                    //existentFlag

                    var api = this.existentFlag ? 'user/updateTenant' : 'user/registerTenant';

                    //axios.post('user/registerTenant', params, {
                    axios.post(api, params, {
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': accessToken()
                        }
                    }).then(response => {
                        this.reloadretrieveTenantList();
                        this.$refs['modalRequestLicense'].hide();

                        if(!this.existentFlag) {
                            this.showMessage(0, "Tenant 추가가 완료되었습니다.");
                        } else {
                            this.showMessage(0, "Tenant 수정이 완료되었습니다.");                            
                        }
                    }).catch(error => {
                        if (error.status != 401) {
                            this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                        }
                    }).finally(() => {
                        this.requestTenantLoading = false;
                        this.submitted = false;
                    });
                }
            });
        },
        deleteTenant() {
            this.submitted = false;
            this.requestTenantLoading = true;
           
            var params = {
                'tenantId': this.tenantDetail.tenantId.trim()
            };

            axios.get('user/deleteTenant', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.reloadretrieveTenantList();
                this.$refs['modalRequestLicense'].hide();

                this.showMessage(0, "Tenant 삭제가 완료되었습니다.");
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.requestTenantLoading = false;
            });
        }
    },
    created() {
        this.retrieveTenantList();
        // this.$store.dispatch('retrievePeonList'); 
    }
}

</script>

<style scoped>
</style>
